import { render, staticRenderFns } from "./anniversaryPoints.vue?vue&type=template&id=3512a8bb&scoped=true&"
import script from "./anniversaryPoints.vue?vue&type=script&lang=js&"
export * from "./anniversaryPoints.vue?vue&type=script&lang=js&"
import style0 from "./anniversaryPoints.vue?vue&type=style&index=0&id=3512a8bb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3512a8bb",
  null
  
)

export default component.exports